import { Component, OnInit } from '@angular/core';
import { LegacyLabel } from '../inputs/common/legacy-label';

/**
 * Labeled data with normal labels and bold data
 */
@Component({
  selector: 'app-labeled-data',
  templateUrl: './labeled-data.component.html',
  styleUrls: ['./labeled-data.component.scss']
})
export class LabeledDataComponent extends LegacyLabel implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
